<template>
  <div class="n3-show-card relative">
    <div
      class="w-[80px] z-[20] absolute top-[-5px] left-2"
      v-if="item.tagOffer"
    >
      <n-3-badge-svg :label="item.tagOffer" />
    </div>
    <div class="flex">
      <div class="image" v-if="item.image || slots.image">
        <img :src="item.image" v-if="item.image" alt="Image" class="w-20" />
        <slot name="image" />
      </div>
      <div class="content flex-1">
        <div>
          <div class="sub-title" v-if="item.subTitle || slots.subtitle">
            {{ item.subTitle }}
            <slot name="subtitle" />
          </div>
          <div class="title">
            {{ item.title }}
            <slot name="title" />
          </div>
          <div class="sub-title2" v-if="item.subTitle2 || slots.subtitle2">
            {{ item.subTitle2 }}
            <slot name="subtitle2" />
          </div>
        </div>
      </div>
      <div class="time" v-if="item.date || item.time || slots.date">
        <div>
          <div class="date-slot">
            {{ item.date }}
            <slot name="date" />
          </div>
          <div class="time-slot">
            {{ item.time }}
            <slot name="time" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useSlots } from "vue";
import N3BadgeSvg from "../show/N3BadgeSvg.vue";
export default {
  components: { N3BadgeSvg },
  name: "N3ShowList",
  props: ["item"],
  setup() {
    const slots = useSlots();

    return {
      slots,
    };
  },
};
</script>
<style lang="scss">
.n3-show-card {
  background-color: #262626;
  border-radius: 10px;
  padding: 1rem;
  .image {
    width: 64px;
    height: 80px;
    margin-right: 1rem;
    vertical-align: middle;
    display: flex;
    img {
      margin-top: auto;
      margin-bottom: auto;
      border-radius: 6px;
    }
  }
  .content {
    display: grid;
    align-content: center;
    .title {
      font-size: 16px;
      font-weight: 500;
      text-transform: uppercase;
      margin: 5px 0;
    }
    .sub-title {
      font-size: 12px;
    }
  }
  .time {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    margin-left: 1rem;
    .date-slot,
    .time-slot {
      padding: 3px 10px;
    }
    .date-slot {
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      background-color: #646464;
    }
    .time-slot {
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;
      background-color: #000000;
    }
  }
}
</style>
